import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import OrderStatusBadge from '../../Shared/OrderStatusBadge';
import { formatAmount, formatDateTime} from 'src/Common/utils';

const Menu = ({ id }) => (
    <div className="dropdown">
        <a className="btn btn-sm btn-icon-only text-light"
            href="javascript:void(0)" /* eslint-disable-line no-script-url */
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
        >
            <i className="fas fa-ellipsis-v" />
        </a>
        <div className="dropdown-menu dropdown-menu-right dropdown-menu-arrow">
            <Link className="dropdown-item" to={`/vendas/${id}`}>Detalhes</Link>
            {/* <a className="dropdown-item" href="#">Cancelar</a> */}
        </div>
    </div>
);

const NotAvailableAmount = () => (
    <small>Não Disponível</small>
);

export default class TableRow extends Component {
    render() {
        const { id, amount, entity, portalOrder, commissionTransfer, createdAt} = this.props;

        let name = ""
        let protocol = portalOrder.order["protocol"]
        let order_id = portalOrder["id"]
        let status = ""
        if (commissionTransfer) {
           status = commissionTransfer.transfer.status
           console.log(status)
        }
        if (entity.portalUser) {
          name = "Vendedor - " + entity.portalUser["user"]["name"]
        }else if (entity.establishment) {
          name = "Estabelecimento - " + entity.establishment["title"]
        }else if (entity.operator){
          name = "Operador - " + entity.operator["title"]
        }

        return (
            <tr>
              <td>{<Link to={`/vendas/${order_id}`}>{protocol}</Link>}</td>
              <td>{name}</td>
              <td>{formatAmount(amount)}</td>
              <td>
              {status === 'TRANSFER_SUCCESSFUL'?
                <span className="badge badge-success">Recebido</span>
                :
                <span className="badge badge-warning">A receber</span>
              }
              </td>
              <td>{formatDateTime(createdAt)}</td>
            </tr>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Commissions/TableRow.js